import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PackRackGlyph = /*#__PURE__*/createElement("g", {
  id: "pack_rack"
}, /*#__PURE__*/createElement("path", {
  d: "M66.67 25.38v33.25H17.33V25.38h49.34m1-3H16.33c-1.1 0-2 .9-2 2v35.25c0 1.1.9 2 2 2h51.33c1.1 0 2-.9 2-2V24.38c.01-1.11-.89-2-1.99-2z"
}), /*#__PURE__*/createElement("path", {
  d: "M53.22 39.2v5.12l1.27.9c1.33.93 2.12 2.45 2.12 4.06 0 2.74-2.23 4.97-4.97 4.97s-4.97-2.23-4.97-4.97c0-1.61.79-3.13 2.12-4.06l1.27-.9V39.2h3.16m3-3h-9.15v6.56a7.948 7.948 0 00-3.39 6.52c0 4.4 3.57 7.97 7.97 7.97s7.97-3.57 7.97-7.97c0-2.7-1.34-5.08-3.39-6.52V36.2h-.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M59.69 58.69H43.61v-1.44c0-.55 2.45-2 3-2h10.08c.55 0 3 1.45 3 2v1.44zm4.98-.03h-3V39.67c-.06-.1-.57-.47-1.43-.47H47.07v-3h13.17c2.48 0 4.43 1.52 4.43 3.47v18.99zM28.88 39.2v5.12l1.27.9c1.33.93 2.12 2.45 2.12 4.06 0 2.74-2.23 4.97-4.97 4.97s-4.97-2.23-4.97-4.97c0-1.61.79-3.13 2.12-4.06l1.27-.9V39.2h3.16m3-3h-9.15v6.56a7.948 7.948 0 00-3.39 6.52c0 4.4 3.57 7.97 7.97 7.97s7.97-3.57 7.97-7.97c0-2.7-1.34-5.08-3.39-6.52V36.2h-.01z"
}), /*#__PURE__*/createElement("path", {
  d: "M35.35 58.69H19.27v-1.44c0-.55 2.45-2 3-2h10.08c.55 0 3 1.45 3 2v1.44zm4.97-.03h-3V39.67c-.06-.1-.57-.47-1.43-.47H22.73v-3H35.9c2.48 0 4.43 1.52 4.43 3.47v18.99z"
}));
const PackRack = createSvg({
  name: 'pack_rack',
  path: PackRackGlyph
});

export default PackRack;
export { PackRackGlyph };
